import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import React, { PropsWithChildren } from 'react'

import { PenIcon } from '../../icons'
import ActionButton from './action-button'
import Typography from './typography'

type EditableBoxProps = {
  id?: string
  title?: string
  subtitle?: React.ReactNode
  className?: string
  mode?: 'space' | 'none'
  containerMode?: 'parent' | 'admin'
  onEdit?: () => void
}

export const EditableInnerBoxTitle: React.FC<PropsWithChildren<EditableBoxProps>> = ({
  title,
  subtitle,
  mode = 'space',
  containerMode,
  onEdit
}) => {
  return (
    <>
      <div className="flex items-center justify-between ">
        <div className="flex items-center gap-3 mobile:flex-col mobile:items-start">
          <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
            {title}
          </Typography>
          {subtitle}
        </div>

        {onEdit && containerMode === 'admin' && (
          <ActionButton variant="grey" icon={PenIcon} onClick={onEdit} />
        )}
      </div>
      {mode === 'space' && <div className="h-4" />}
    </>
  )
}

const EditableInnerBox: React.FC<PropsWithChildren<EditableBoxProps>> = ({
  id,
  title,
  subtitle,
  children,
  className,
  containerMode = 'admin',
  mode = 'space',
  onEdit
}) => {
  return (
    <div
      id={id}
      className={cn(
        'p-4 border border-grey-light bg-white-hover rounded flex flex-col mobile:p-3',
        className
      )}
    >
      {title && (
        <EditableInnerBoxTitle
          title={title}
          subtitle={subtitle}
          onEdit={onEdit}
          mode={mode}
          containerMode={containerMode}
        />
      )}
      {children}
    </div>
  )
}

export default EditableInnerBox
